(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .controller('BIAProfileIntroductionController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'itemTaskService'];

    function Controller($scope, $state, $stateParams, itemTaskService) {

        // On Begin BCM by BCC
        $scope.completeBCCIntroductionItemTask = function () {
            itemTaskService
                .completeItemTaskByNameForUser('NeedBCCExplanationAcknowledgement')
                .then(function () {
                    $state.go('biaProfile.edit', {BIAProfileID: $stateParams.biaProfileId});
                });
        };
    }
})();